import { RouteError } from '@/components/route-error'
import { createFileRoute } from '@tanstack/react-router'
import { RoutePending } from '@/components/route-pending'
import { SuppliersPage } from './_dashboard.catalog.suppliers'

export const Route = createFileRoute('/_dashboard/catalog/suppliers/$item')({
  pendingComponent: RoutePending,
  errorComponent: RouteError,
  component: SuppliersItemPage,
})

function SuppliersItemPage() {
  const { item } = Route.useParams()
  return <SuppliersPage selectedId={item} />
}
